// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"mais-vendidos-melhores-precos_wrapper__6QpZ7"};